

import React, { useRef } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import { iconManhole, iconFobCanton, iconCouplingCanton, iconPonBox, iconPillar } from '../Constants/ConstantsOptics';
import 'leaflet/dist/leaflet.css';

const ModalMapConnection = ({ open, onClose, groupedCoordinatesWithColorTypeAndWidth, filteredWellData, filteredFobData, filteredCouplingData,
  filteredPonBoxData, filteredPillarData }) => {

  const mapRef = useRef();

  const close = () => {
    onClose();
  };

  const { coordinates, color, type, width } = groupedCoordinatesWithColorTypeAndWidth;

  const initialCenter = coordinates.length > 0 ? coordinates[0] : [50.45018, 30.52294];

  return (
    <Dialog open={open} className="modalStyleMap" fullWidth maxWidth={false}>
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Связи на карте</label>
        <hr className='horizontalLineModalUpTer' />
        <div style={{ height: '600px', width: '1140px', borderRadius: '10px', marginTop: '10px' }}>
          <MapContainer
            center={initialCenter}
            zoom={18}
            minZoom={12}
            style={{ height: '100%', width: '100%', borderRadius: '10px' }}
            ref={mapRef}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            
            <Polyline
              positions={coordinates}
              pathOptions={{
                color: color.trim(),
                weight: width,
                dashArray: type !== 'solid ' ? '5,10' : null,
              }}
            />
            
            {/* filteredWellData */}
            {filteredWellData.map(well => (
              <Marker
                key={well.id}
                icon={iconManhole}
                position={[well.latitude, well.longitude]}
              >
                <Popup className="custom-popup">
                  <div>
                    <h5>Колодец</h5>
                    <hr className='horizontalLineModalUpTer' />
                    <p>ID: <strong>{well.id}</strong></p>
                    <p>Собственник: <strong>{well.ownerWellName}</strong></p>
                    <p>Комментарий: <strong>{well.description}</strong></p>
                  </div>
                </Popup>
              </Marker>
            ))}

             {/* filteredFobData */}
             {filteredFobData.map(fob => (
              <Marker
                key={fob.id}
                icon={iconFobCanton}
                position={[fob.latitude, fob.longitude]}
              >
                <Popup className="custom-popup">
                  <div>
                    <h5>Фоб</h5>
                    <hr className='horizontalLineModalUpTer' />
                    <p>ID: <strong>{fob.id}</strong></p>
                    <p>Name: <strong>{fob.fobName}</strong></p>
                    <p>Комментарий: <strong>{fob.description}</strong></p>
                    {/* <p>Собственник: <strong>{well.ownerWellName}</strong></p> */}
                  </div>
                </Popup>
              </Marker>
            ))}

              {/* filteredCouplingData */}
              {filteredCouplingData.map(coupling => (
              <Marker
                key={coupling.id}
                icon={iconCouplingCanton}
                position={[coupling.latitude, coupling.longitude]}
              >
                <Popup className="custom-popup">
                  <div>
                    <h5>Муфта</h5>
                    <hr className='horizontalLineModalUpTer' />
                    <p>ID: <strong>{coupling.id}</strong></p>
                    <p>Name: <strong>{coupling.couplingName}</strong></p>
                    <p>Комментарий: <strong>{coupling.description}</strong></p>
                  </div>
                </Popup>
              </Marker>
            ))}

            {/* filteredPonBoxData */}
            {filteredPonBoxData.map(ponBox => (
              
              <Marker
                key={ponBox.id}
                icon={iconPonBox}
                position={[ponBox.latitude, ponBox.longitude]}
              >
                <Popup className="custom-popup">
                  <div>
                    <h5>Пон-бокс</h5>
                    <hr className='horizontalLineModalUpTer' />
                    <p>ID: <strong>{ponBox.id}</strong></p>
                    <p>Name: <strong>{ponBox.fobName}</strong></p>
                    <p>Комментарий: <strong>{ponBox.description}</strong></p>
                  </div>
                </Popup>
              </Marker>
            ))}

               {/* filteredPillarData */}
               {filteredPillarData.map(pillar => (
              
              <Marker
                key={pillar.id}
                icon={iconPillar}
                position={[pillar.latitude, pillar.longitude]}
              >
                <Popup className="custom-popup">
                  <div>
                    <h5>Опора</h5>
                    <hr className='horizontalLineModalUpTer' />
                    <p>ID: <strong>{pillar.id}</strong></p>
                    <p>Name: <strong>{pillar.ownerPillarName}</strong></p>
                    <p>Комментарий: <strong>{pillar.description}</strong></p>
                  </div>
                </Popup>
              </Marker>
            ))}

          </MapContainer>
        </div>
        <hr className='horizontalLineModalUpTer' />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} class='buttonIsHideModalUpTer'>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalMapConnection;